import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PhotosHero from './components/PhotosHero';
import PhotosGallery from './components/PhotosGallery';

const PhotosPage = () => {
  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "Foto Galerij – NGP Renovatieproject",
      "url": `${import.meta.env.VITE_SITE_URL ?? ''}/photos`,
      "description": "Bekijk onze renovatieprojecten in foto's. Voor- en na-foto's van badkamer verbouwing, keuken renovatie, vloeren en buitengevel renovatie in Antwerpen en omgeving.",
      "about": {
        "@type": "ImageGallery",
        "name": "Renovatie Voor & Na Galerij",
        "description": "Fotogalerij van voltooide renovatieprojecten door NGP Renovatieproject in Antwerpen."
      },
      "provider": {
        "@type": "Organization",
        "name": "NGP Renovatieproject",
        "url": `${import.meta.env.VITE_SITE_URL ?? ''}`
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-photos';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const existing = document.getElementById('schema-photos');
      if (existing) existing.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <PhotosHero />
      <PhotosGallery />
      <Footer />
    </div>
  );
};

export default PhotosPage;
